<div class="chat-window">
  <div #scrollEl class="chat-messages" (scroll)="onScroll()">
    @if (messages.length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">chat_bubble_outline</mat-icon>
        <p class="empty-text">
          {{ 'colimind.chatEmptyState' | translate }}
        </p>
      </div>
    }
    @for (msg of messages; track msg) {
      <div
        class="message-row"
        [class.message-row--user]="msg.role === 'user'"
        [class.message-row--assistant]="msg.role === 'assistant'"
      >
        @if (msg.role === 'user') {
          <div class="user-message">
            <div class="user-bubble">{{ msg.text }}</div>
            <div class="message-meta">
              @if (messageTime(msg); as time) {
                <span class="message-time">{{ time }}</span>
              }
              <button
                type="button"
                mat-icon-button
                class="message-meta-copy"
                [matTooltip]="(copiedMessage() === msg ? 'colimind.copied' : 'colimind.copyQuestion') | translate"
                (click)="copyQuestion(msg)">
                <mat-icon>{{ copiedMessage() === msg ? 'check' : 'content_copy' }}</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                class="message-meta-bookmark"
                [matTooltip]="'colimind.saveAsSuggestion' | translate"
                (click)="saveAsSuggestion.emit(msg.text); $event.stopPropagation()">
                <mat-icon>bookmark_border</mat-icon>
              </button>
            </div>
          </div>
        }
        <!-- Until the first content arrives, only the loading dots are shown. -->
        @if (msg.role === 'assistant' && (msg.text || msg.response || msg.aborted || msg.error || msg.questions?.length)) {
          <div class="assistant-bubble">
            @if (msg.text || msg.response || !msg.questions?.length) {
              <colimo-response-card
                [text]="msg.text"
                [response]="msg.response"
                [timestamp]="msg.timestamp"
                [streaming]="loading && $last"
              />
            }
            @if (msg.questions?.length) {
              <colimo-agent-questions
                [questions]="msg.questions"
                [answers]="msg.answers"
                [disabled]="loading || !$last"
                (answer)="answerQuestions.emit({ message: msg, answers: $event })"
              />
            }
            @if (msg.error) {
              <p class="assistant-error">
                <mat-icon class="assistant-aborted-icon">error_outline</mat-icon>
                {{ (msg.error.kind === 'server' ? 'colimind.serverError' : 'colimind.chatError') | translate }}
              </p>
              @if (debug.enabled() && msg.error.details) {
                <details class="assistant-error-details">
                  <summary>Details</summary>
                  <pre>{{ msg.error.details }}</pre>
                </details>
              }
            } @else if (msg.aborted) {
              <p class="assistant-aborted">
                <mat-icon class="assistant-aborted-icon">block</mat-icon>
                {{ 'colimind.answerCancelled' | translate }}
              </p>
            }
          </div>
        }
      </div>
    }
    @if (loading) {
      <div class="loading-area">
        <div class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        @if (status) {
          <span class="loading-status">{{ status | translate }}</span>
        }
      </div>
    }

  </div>

  @if (showScrollButton) {
    <button
      type="button"
      class="scroll-to-bottom"
      [class.scroll-to-bottom--unread]="unreadCount > 0"
      [matTooltip]="unreadCount > 0 ? ('colimind.unreadMessages' | translate: { count: unreadCount }) : ('colimind.scrollToBottom' | translate)"
      (click)="scrollToBottom()"
    >
      <mat-icon>arrow_downward</mat-icon>
      @if (unreadCount > 0) {
        <span class="scroll-badge">{{ unreadCount }}</span>
      }
    </button>
  }

  <div class="chat-input-area">
    <div class="chat-input-wrap">
      <div class="chat-input-box" [class.chat-input-box--cue]="highlightInput">
        <textarea
          #inputEl
          [(ngModel)]="input"
          name="question"
          [disabled]="loading"
          [placeholder]="'colimind.inputPlaceholder' | translate"
          autocomplete="off"
          rows="1"
          (keydown.enter)="onEnter($event)"
          (input)="autoResize($event)"
          class="chat-input-textarea"
        ></textarea>
        <div class="chat-input-actions">
          @if (!loading) {
            <button
              type="button"
              class="chat-input-submit"
              [disabled]="!input.trim()"
              (click)="submit()"
            >
              <mat-icon>arrow_upward</mat-icon>
            </button>
          }
          @if (loading) {
            <button
              type="button"
              class="chat-input-submit chat-input-stop"
              [matTooltip]="'colimind.stopGeneration' | translate"
              (click)="stop.emit()"
            >
              <mat-icon>stop</mat-icon>
            </button>
          }
        </div>
      </div>
      <p class="chat-disclaimer">{{ 'colimind.disclaimer' | translate }}</p>
    </div>
  </div>
</div>
